import { useState } from 'react'

import { FxButton, FxIcon } from '@/components/fx'
import { ChangePasswordDialog } from './ChangePasswordDialog'

/**
 * "Anmeldung und Sicherheit".
 *
 * Three rows are drawn on `Einstellungen.dc.html`; one of them has a
 * gateway behind it. The other two are not built, and each for a reason
 * worth keeping written down:
 *
 * - **Verknüpfte Konten.** `oauth_identities` exists as a table, but there
 *   is no endpoint that lists, links or unlinks one — the only way an
 *   identity is created is by signing in with it. A "Google verknüpfen"
 *   button would have nothing to call, and a list of linked accounts would
 *   have nothing to read.
 * - **Überall abmelden.** `POST /v1/auth/logout` revokes the current
 *   refresh family only. The button would promise to end the session on the
 *   lost phone and would in fact end the one it was pressed on, which is
 *   the worst possible outcome for the very situation it is drawn for.
 *
 * The password row also loses its "Zuletzt geändert vor 3 Monaten": the
 * timestamp is stored (`user_credentials.password_updated_at`) but no
 * response carries it, and the one thing a security screen must not do is
 * make up a date.
 */
export function SecuritySection() {
  const [dialogOpen, setDialogOpen] = useState(false)
  const [changed, setChanged] = useState(false)

  return (
    <section className="flex flex-col gap-6">
      <h2 className="text-tile-title text-text">Anmeldung und Sicherheit</h2>
      <div className="flex flex-col rounded-sm bg-surface shadow-raised">
        <div className="flex flex-wrap items-center gap-5 p-5 sm:px-6">
          <FxIcon name="password" size={24} className="text-primary-text" />
          <div className="min-w-[12rem] flex-grow">
            <p className="text-body-strong text-text">Passwort</p>
            <p className="text-small text-text-muted">
              Mindestens 8 Zeichen. Sie brauchen dafür Ihr aktuelles Passwort.
            </p>
          </div>
          <FxButton variant="tonal" onClick={() => setDialogOpen(true)}>
            Passwort ändern
          </FxButton>
        </div>
      </div>
      <p aria-live="polite" className="text-small text-success-text">
        {changed && 'Ihr Passwort wurde geändert.'}
      </p>

      <ChangePasswordDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        onChanged={() => setChanged(true)}
      />
    </section>
  )
}
